import { SVGIconComponent } from './types';

export const LockerpointLogo: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="351px"
    height="474px"
    viewBox="0 0 351 474"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color, ...style }}
    className={className}
  >
    <defs>
      <linearGradient x1="8.4043628%" y1="49.9999943%" x2="94.7048388%" y2="49.9999943%" id="linearGradient-1">
        <stop stopColor="#26ADA7" offset="0%"></stop>
        <stop stopColor="#174885" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g id="Lockerpoint-icon" stroke="none" fill="none" fillRule="nonzero">
      <path
        d="M324.01,85.51 C317.6,74.87 283.91,21.59 216.16,4.88 C182.56,-3.41 154.01,0.62 138.23,4.15 C66.7,20.17 31.2,76.82 25.94,85.51 C25.94,85.51 -2.99,132.91 0.25,191.73 C0.46,195.56 0.74,198.62 0.96,200.78 C3.51,226.76 12.25,259.66 103.74,382.48 C132.35,420.9 157.08,452.03 174.53,473.52 L175.44,473.52 C192.88,452.03 217.62,420.9 246.23,382.48 C337.72,259.65 346.45,226.76 349.01,200.78 C349.22,198.63 349.5,195.56 349.72,191.74 C352.95,133.02 324.03,85.51 324.03,85.51 L324.01,85.51 Z M272.08,218.95 C272.08,224.45 269.13,229.52 264.35,232.23 L184.15,277.71 C179.48,280.36 173.76,280.36 169.09,277.71 L88.89,232.23 C84.11,229.52 81.16,224.45 81.16,218.95 L81.16,128.46 C81.16,122.96 84.11,117.89 88.89,115.18 L169.09,69.7 C173.76,67.05 179.48,67.05 184.15,69.7 L264.35,115.18 C269.13,117.89 272.08,122.96 272.08,128.46 L272.08,218.95 Z"
        id="Shape"
        fill="url(#linearGradient-1)"
      ></path>
    </g>
  </svg>
);
